import { type NotNull } from '@src/types/utils';
import { directusClient } from '@src/api/DirectusClient.ts';
import type { CountryDTO, OrganizationDto } from '@src/api/api.types.ts';

export type Country = {
  id: string;
  label: string | null;
  subdivision_code: string;
  country_code: string | null;
};

export const mapCountryDTOtoCountry = (
  dto: CountryDTO | NotNull<OrganizationDto['country']>,
): Country => ({
  id: dto.id,
  label: dto.label ?? null,
  subdivision_code: dto.subdivision_code ?? '',
  country_code: dto.country_code ?? '',
});

export class CountryService {
  async getCountries(): Promise<Country[]> {
    return (await directusClient.getCountries()).map(mapCountryDTOtoCountry);
  }

  async getCountryById(id: string): Promise<Country | null> {
    return mapCountryDTOtoCountry(await directusClient.getCountryById(id));
  }

  async getCountryByCountryCode(countryCode: string): Promise<Country | null> {
    const countries =
      await directusClient.getCountriesByCountryCode(countryCode);
    if (countries.length === 0 || !countries[0]) {
      return null;
    }
    return mapCountryDTOtoCountry(countries[0]);
  }

  async getCountryBySubdivisionCode(
    subdivisionCode: string,
  ): Promise<Country | null> {
    const countries =
      await directusClient.getCountriesBySubdivisionCode(subdivisionCode);
    if (countries.length === 0 || !countries[0]) {
      return null;
    }
    return mapCountryDTOtoCountry(countries[0]);
  }
}

const countryService = new CountryService();
export default countryService;
